import { render, staticRenderFns } from "./True-False.vue?vue&type=template&id=2387ca49"
import script from "./True-False.vue?vue&type=script&lang=js"
export * from "./True-False.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports